/* eslint-disable jsx-a11y/iframe-has-title */
import { CodepenOutlined } from "@ant-design/icons";
import { Col, Image, ImageProps, Modal, Row } from "antd";
import axios from "axios";
import b64toBlob from "b64-to-blob";
import { ILayer } from "dxf-parser";
import { DxfViewer } from "dxf-viewer";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { CuttingType } from "../../models/CuttingType";
import { Part, PartPreview } from "../../models/Part";
import partServices from "../../services/part.service";
import InputInlineApi from "../Form/InputInlineApi";
import LoadingIcon from "../SVGs/LoadingIcon";
import "./partImage.module.scss";

interface DefaultProps extends ImageProps {
  part?: Part;
  onLayersSelected?: any;
  showPartName?: boolean | false;
  readonly?: boolean;
  partPreview?: PartPreview;
  cuttingtype?: CuttingType;
}

const isDxf = (url?: string) => {
  return !!url && url.indexOf(".dxf") > -1;
};
function PartImage(props: DefaultProps) {
  const {
    part,
    showPartName,
    onLayersSelected,
    readonly = false,
    partPreview,
    cuttingtype, // use for fast review only
    ...imageProps
  } = props;
  const { src, width = "auto", height = "auto" } = props;
  const { t } = useTranslation();
  const [isOpenPreview, setIsOpenPreview] = useState(false);
  const [isOpenDxfPreview, setIsOpenDxfPreview] = useState(false);
  const [srcFrame, setSrcFrame] = useState("");
  const [key] = useState(Date.now());
  const [loading, setLoading] = useState(true);
  const [layers, setLayers] = useState<ILayer[]>();
  const [dxfViewer, setDxfViewer] = useState<DxfViewer>();
  const [isOpenSheetMetalPreview, setIsOpenSheetMetalPreview] = useState(false);
  const [svgBlobUrl, setSvgBlobUrl] = useState<string | null>(null);
  const [dxfSvgBlobUrl, setDxfSvgBlobUrl] = useState<string | null>(null);

  const getIFrame = async () => {
    try {
      const rs = await partServices.get3dViewer({
        margin: 0,
        width: (window.innerWidth * 0.6).toFixed(0),
        height: (window.innerWidth * 0.386).toFixed(0),
      });
      setSrcFrame(rs);
    } catch (error) {}
  };

  const sendMessageToClassmateCloudFrame = (
    messageType: string,
    messageContent: any
  ) => {
    try {
      if (!messageContent) messageContent = {};
      var message = { type: messageType, content: messageContent };
      const el: any = document.getElementById(
        `classmateCloudFrame-${key}-${part?.id}`
      );
      el.contentWindow.postMessage(message, srcFrame);
    } catch (error) {
      // console.log(error);
    }
  };

  const get3dModel = async () => {
    try {
      const rs = await partServices.get3dModel(part?.id);
      sendMessageToClassmateCloudFrame("loadModel", {
        s3dModel: new File([b64toBlob(rs)], "model.s3d"),
      });
    } catch (error) {}
    setLoading(false);
  };

  const openSheetMetalPreviewModal = async () => {
    console.log("image:setIsOpenSheetMetalPreview", part);
    
    if (part?.previewSvgUrl) {
      setLoading(true);
      setIsOpenSheetMetalPreview(true);
      if (svgBlobUrl) {
        setLoading(false);
        return;
      }
      const response = await axios.get(part.previewSvgUrl, {
        responseType: "blob",
      });
      const blob = new Blob([response.data], { type: "image/svg+xml" });
      const blobUrl = URL.createObjectURL(blob);
      setSvgBlobUrl(blobUrl);
      setLoading(false);
      return;
    } else if (partPreview?.previewSvgUrl || part?.previewPngUrl) {
      setIsOpenSheetMetalPreview(true);
      return;
    }

    return;
  };

  const openDxfPreviewModal = async () => {
    if (part?.previewProcessedUrl) {
      setIsOpenDxfPreview(true);
    }

    if (part?.previewSvgUrl) {
      setLoading(true);
      setIsOpenDxfPreview(true);

      if (dxfSvgBlobUrl) {
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(part.previewSvgUrl, {
          responseType: "blob",
        });
        const blob = new Blob([response.data], { type: "image/svg+xml" });
        const blobUrl = URL.createObjectURL(blob);
        setDxfSvgBlobUrl(blobUrl);
      } catch (error) {
        throw error;
      }

      setLoading(false);
    } else if (partPreview?.previewSvgUrl || part?.previewPngUrl) {
      setIsOpenDxfPreview(true);
    }
  };

  // useEffect(() => {
  //   if (part?.dxfFileName) {
  //     getDxfContent();
  //   }
  // }, [src]);
  useEffect(() => {
    if (isOpenPreview) getIFrame();
  }, [isOpenPreview]);

  useEffect(() => {
    // if (isOpenDxfPreview) {
    //   renderToCanvas(dxf);
    // } else {
    // }
  }, [isOpenDxfPreview]);

  const onToggleLayer = (e: any) => {
    const layerName = e.target.value;
    const visible = e.target.checked;
    const i: any = layers?.findIndex((l) => l.name == layerName);
    if (i > -1 && !!layers) {
      layers[i].visible = !layers[i].visible;
      setLayers([...layers]);
    }
    if (dxfViewer) {
      dxfViewer.ShowLayer(layerName, visible);
    }
  };

  const renderModelPreviewDxfFile = (part: Part | undefined) => {
    if (!part) {
      return renderPartPreviewDxfFile();
    }

    if (part.previewProcessedUrl) {
      return (
        <img
          src={part.previewProcessedUrl}
          alt={`${part?.id}-${part?.partFileName}`}
        />
      );
    }

    if (part.previewSvgUrl) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            maxHeight: "80vh",
          }}
        >
          {loading && (
            <div className="icon-loading">
              <LoadingIcon />
            </div>
          )}
          {dxfSvgBlobUrl && (
            <img
              style={{ height: "600px", width: "800px" }}
              src={dxfSvgBlobUrl}
              alt={`${part?.id}-${part?.partFileName}`}
            />
          )}
        </div>
      );
    } else if(part.previewPngUrl) {
      return <>
        <img
          style={{ maxWidth: "100%", maxHeight: "100%" }}
          src={part?.previewPngUrl}
          alt={part && `${part?.id}-${part?.partFileName}`}
        />
      </>
    }
  };

  const renderPartPreviewDxfFile = () => {
    if (!partPreview) {
      return <></>;
    }

    if (partPreview.previewSvgUrl) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            maxHeight: "80vh",
          }}
        >
          <img
            style={{ height: "600px", width: "800px" }}
            src={makeBase64SvgPreview()}
          />
        </div>
      );
    }
  };

  const renderPartPreviewMillingFile = () => {
    if (!part) {
      return renderPartPreviewDxfFile();
    }

    return (
      <>
        {loading && (
          <div className="icon-loading">
            <LoadingIcon />
          </div>
        )}
        {srcFrame && (
          <iframe
            id={`classmateCloudFrame-${key}-${part?.id}`}
            className="classmateCloudFrame"
            style={{
              width: "100%",
            }}
            height={`${window.innerWidth * 0.386 - 20}px`}
            src={srcFrame}
            scrolling="no"
            onLoad={get3dModel}
          ></iframe>
        )}
      </>
    );
  };

  const handleChangePartName = async (name: string) => {
    try {
      const rs: Part = await partServices.updateName(part?.id, name);

      return rs.name;
    } catch (error) {}
  };

  const makeBase64PngPreview = () => {
    if (!partPreview?.previewPngUrl) {
      return undefined;
    }

    return "data:image/png;base64," + partPreview?.previewPngUrl;
  };

  const makeBase64SvgPreview = () => {
    if (!partPreview?.previewSvgUrl) {
      return undefined;
    }

    return "data:image/svg+xml;base64," + partPreview?.previewSvgUrl;
  };

  const renderPartPreviewStepFile = () => {
    if (svgBlobUrl) {
      return (
        <>
          {loading && (
            <div className="icon-loading">
              <LoadingIcon />
            </div>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              maxHeight: "80vh",
            }}
          >
            {svgBlobUrl && (
              <img
                style={{ maxWidth: "100%", maxHeight: "100%" }}
                src={svgBlobUrl}
                alt={part && `${part?.id}-${part?.partFileName}`}
              />
            )}
          </div>
        </>
      );
    } else if (partPreview?.previewSvgUrl) {
      return renderPartPreviewDxfFile();
    } else if (part?.previewPngUrl) {
      return <img
        style={{ maxWidth: "100%", maxHeight: "100%" }}
        src={part?.previewPngUrl}
        alt={part && `${part?.id}-${part?.partFileName}`}
      />
    }
  };

  return (
    <>
      {showPartName && (
        <Row style={{ width: "100%" }}>
          <Col style={{ width: "100%" }} span={24}>
            <div className="sub-l">
              {readonly && <>{part?.name}</>}
              {!readonly && (
                <InputInlineApi
                  callBack={handleChangePartName}
                  key={part?.name}
                  value={part?.name}
                  name="partName"
                  label={t("part.partName")}
                />
              )}
            </div>
          </Col>
        </Row>
      )}
      {(part?.cuttingType === CuttingType.MILLING_AND_TURNING ||
        (cuttingtype == CuttingType.MILLING_AND_TURNING &&
          partPreview?.previewPngUrl)) && (
        <Image
          {...imageProps}
          width={width}
          height={""}
          preview={{
            visible: false,
            mask: <CodepenOutlined style={{ fontSize: "1em" }} />,
          }}
          src={src || makeBase64PngPreview() || "error"}
          onClick={setIsOpenPreview.bind(null, true)}
          fallback="data:image/png;base64,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"
        />
      )}
      {(part?.cuttingType === CuttingType.SHEET_METAL_STP ||
        (cuttingtype == CuttingType.SHEET_METAL_STP &&
          partPreview?.previewPngUrl)) && (
        <>
          <Image
            {...imageProps}
            width={width}
            height={""}
            preview={{
              visible: false,
              mask: <CodepenOutlined style={{ fontSize: "1em" }} />,
            }}
            src={src || makeBase64PngPreview() || part?.previewPngUrl || "error"}
            onClick={openSheetMetalPreviewModal}
            fallback="data:image/png;base64,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"
          />
        </>
      )}
      {(part?.cuttingType === CuttingType.SHEET_METAL_DXF ||
        part?.cuttingType === CuttingType.SHEET_METAL_DWG ||
        (cuttingtype == CuttingType.SHEET_METAL_DXF &&
          partPreview?.previewPngUrl)) && (
        <Image
          {...imageProps}
          width={width}
          height={""}
          preview={{
            visible: false,
            mask: <CodepenOutlined style={{ fontSize: "1em" }} />,
          }}
          src={part?.previewPngUrl || makeBase64PngPreview() || "error"}
          onClick={openDxfPreviewModal}
          fallback="data:image/png;base64,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"
        />
      )}
      <Modal
        open={isOpenPreview}
        width={"calc(60vw - 46px)"}
        onCancel={setIsOpenPreview.bind(null, false)}
        footer={null}
        centered
        className="v3dmodel"
      >
        {renderPartPreviewMillingFile()}
      </Modal>
      <Modal
        open={isOpenDxfPreview}
        width={"calc(60vw - 46px)"}
        onCancel={setIsOpenDxfPreview.bind(null, false)}
        footer={null}
        centered
        className="v3dmodel"
        maskClosable={false}
      >
        {renderModelPreviewDxfFile(part)}
      </Modal>
      <Modal
        open={isOpenSheetMetalPreview}
        width={"calc(60vw - 46px)"}
        onCancel={setIsOpenSheetMetalPreview.bind(null, false)}
        footer={null}
        centered
        className="v3dmodel"
      >
        {renderPartPreviewStepFile()}
      </Modal>
    </>
  );
}

PartImage.isDxf = isDxf;

export default PartImage;
